import { render, staticRenderFns } from "./MobileCorporateCulture.vue?vue&type=template&id=36845a0f&scoped=true&"
import script from "./MobileCorporateCulture.vue?vue&type=script&lang=js&"
export * from "./MobileCorporateCulture.vue?vue&type=script&lang=js&"
import style0 from "./MobileCorporateCulture.vue?vue&type=style&index=0&id=36845a0f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36845a0f",
  null
  
)

export default component.exports